// use client: useEffect adds the `page-alrajhi` body class on mount
'use client'

import '../digital-banking.css'

import { useEffect } from 'react'

import Deals from '@/sections/ComingSoon/Deals'
import FAQs from '@/sections/ComingSoon/FAQs'
import Features from '@/sections/ComingSoon/Features'
import GetStarted from '@/sections/ComingSoon/GetStarted'
import InstallApp from '@/sections/ComingSoon/InstallApp'
import LetsConnect from '@/sections/ComingSoon/LetsConnect'
import MyAlrajhiImportance from '@/sections/ComingSoon/MyAlrajhiImportance'

function ComingSoon({ initialData }) {
  // Content comes from the build-time snapshot only. A Strapi publish rebuilds
  // and redeploys the site, so there is nothing to revalidate on mount.
  // See tests/no-client-cms-fetch.spec.ts.
  const data = initialData ?? {}

  useEffect(() => {
    document.body.classList.add('page-alrajhi')
  }, [])

  return (
    <div id="coming-soon-main-container">
      {data?.deals && <Deals dealsData={data?.deals} />}
      {data?.importance && <MyAlrajhiImportance data={data} />}
      {data?.features && <Features data={data} />}
      {data?.getStarted && <GetStarted data={data} />}
      {data?.faqData && <FAQs data={data} />}
      <InstallApp />
      <LetsConnect
        title={'Start your digital banking with MY alrajhi'}
        subtitle={'Submit your details below and our specialists will be in touch soon.'}
      />
    </div>
  )
}

export default ComingSoon
